import React from "react";
import PropTypes from "prop-types";
import AccountName from "components/v3/subscription-details/account-name/AccountName";
import AccountStatus from "components/v3/subscription-details/account-status/AccountStatus";
import SubscriptionStartDate from "components/v3/subscription-details/subscription-start-date/SubscriptionStartDate";
import SubscriptionEndDate from "components/v3/subscription-details/subscription-end-date/SubscriptionEndDate";
import AccountNextBilling from "components/v3/subscription-details/account-next-billing/AccountNextBilling";
import ManageSubscriptionButton from "components/v3/subscription-details/manage-subscription-button/ManageSubscriptionButton";
import CustomerAdmins from "components/v3/subscription-details/customer-admins/CustomerAdmins";
import { pricingStrategy, determineProductDisplayName } from "components/v3/subscription-details/util";
import styles from "../styles.module.scss";

class BulkSubscriptionDetails extends React.Component {
    componentDidMount() {
        this.props.getAdmins();
    }

    render() {
        const {
            isAdmin,
            startDate,
            endDate,
            admins = [],
            type,
            status,
            metadata,
            offerType,
            bulkSubscriptionMetadata = {},
            bloombergSiteUrl,
            adminPanelUrl
        } = this.props;
    
        const accountName = metadata?.productType;
    
        const {
            nextChargePrice,
            nextChargeDate
        } = pricingStrategy(metadata);
    
        const productName = determineProductDisplayName(type, accountName, bulkSubscriptionMetadata.name, offerType);
    
        return (
            <div>
                <div className={ styles.details }>
                    <AccountName name={ productName } />
                    <AccountStatus status={ status } bloombergSiteUrl={ bloombergSiteUrl } />
                    <SubscriptionStartDate startDate={ startDate } />
                    <SubscriptionEndDate status={ status } endDate={ endDate } />
                    <AccountNextBilling
                        status={ status }
                        nextRenewalDate={ nextChargeDate }
                        renewalPrice={ nextChargePrice }
                        showCancelLink={ false }
                        showRenewalPrice={ isAdmin }
                    />
                    <ManageSubscriptionButton
                        isAdmin={ isAdmin }
                        status={ bulkSubscriptionMetadata.status }
                        adminPanelUrl={ adminPanelUrl }
                    />
                    <CustomerAdmins admins={ admins } />
                </div>
            </div>
        );
    }
}

BulkSubscriptionDetails.propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    admins: PropTypes.array,
    status: PropTypes.string.isRequired,
    metadata: PropTypes.object,
    offerType: PropTypes.string,
    bloombergSiteUrl: PropTypes.string.isRequired,
    bulkSubscriptionMetadata: PropTypes.object,
    getAdmins: PropTypes.func.isRequired,
    adminPanelUrl: PropTypes.string.isRequired
};

export default BulkSubscriptionDetails;
